import React, { useState } from 'react';
import { Button, Col, Form, message, Input, Row, Modal } from 'antd';
import { capitalizeWords } from '../../../utils/Constants';
import { getHotelEnquiry } from '../../../services/flight/flightServices';
import { Link } from 'react-router-dom';
import { FaCheck, FaPhoneAlt, FaTimes, FaWhatsapp } from 'react-icons/fa';
import ThankYouModal from '../confirmpage/ThankYouModal';

const PackageBanner = ({ packageData }) => {

  const [isLoading, setIsLoading] = useState(false);
  const [isThankYouModalOpen, setThankYouModalOpen] = useState(false);
  const [form] = Form.useForm();
  const [messageApi, contextHolder] = message.useMessage();

  const handleSubmit = async (values) => {
    setIsLoading(true);

    try {
      const payload = {
        name: values.name,
        email: values.email,
        mobile_number: values.mobile.toString(),
        message_content: values.message,
        enquiry_type: "GENERAL",
      };

      const response = await getHotelEnquiry(payload);
      setThankYouModalOpen(true);
      form.resetFields();
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const [isVisible, setIsVisible] = useState(true);

  const handleClick = () => {
    if (window.innerWidth <= 768) {
      setIsVisible(false);
    }
  };

  return (
    <>
      {contextHolder}
      <section className='PackageBanner'>
        <img loading="lazy" src={packageData?.image_url} alt="" />
        <div className='container'>
          <Row gutter={16} align="middle">
            <Col md={16} sm={24}>
              <div className='Package-cntr'>
                <h2 className='mb-md-4'>SuperbWorldTrip offers {capitalizeWords(packageData?.name)}</h2>
              </div>
            </Col>
            <Col md={8} xs={24}>

              {isVisible && (
                <>
                  <div className="mobile-hide-box d-md-none" onClick={handleClick}>
                    <FaTimes />
                  </div>
                  <div className='card mb-0'>
                    <div className='card-body'>
                      <h3 className='card-title'>Talk To An Expert Travel Advisor</h3>
                      <p className='mb-3'>Get The Best Deals On {packageData?.name} & Special Discounts.</p>
                      <Form
                        form={form}
                        layout="vertical"
                        onFinish={handleSubmit}

                      >
                        <Form.Item
                          name="name"
                          rules={[{ required: true, message: "Please enter your name" }]}
                        >
                          <Input style={{ height: "45px" }} placeholder="Name" />
                        </Form.Item>
                        <Form.Item
                          name="email"
                          rules={[
                            { required: true, message: "Please enter your email" },
                            { type: "email", message: "Please enter a valid email" },
                          ]}
                        >
                          <Input style={{ height: "45px" }} placeholder="Email ID" />
                        </Form.Item>
                        <Form.Item
                          name="mobile"
                          rules={[
                            { required: true, message: "Please enter your mobile number" },
                            { pattern: /^[0-9]{10}$/, message: "Enter a valid 10-digit number" },
                          ]}
                          normalize={(value) => value && value.toString()} // Ensure it's a string
                        >
                          <Input style={{ height: "45px" }} placeholder="Mobile Number" />
                        </Form.Item>
                        <Form.Item
                          name="message"
                          rules={[{ required: true, message: "Please enter your message" }]}
                        >
                          <Input.TextArea rows={4} placeholder="Message" />
                        </Form.Item>

                        <Form.Item>
                          <Button
                            type="primary"
                            htmlType="submit"
                            block
                            loading={isLoading}
                            style={{ padding: "10px 55px" }}
                            aria-label="send"
                          >
                            {isLoading ? "Sending..." : "Send"}
                          </Button>
                        </Form.Item>
                      </Form>
                    </div>
                  </div>
                </>
              )}
            </Col>
          </Row>
        </div>
      </section>

      <ThankYouModal
        isOpen={isThankYouModalOpen}
        setThankYouModalOpen={setThankYouModalOpen}
      />

    </>
  )
}

export default PackageBanner